/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AssignAccountManagerRequest} from '../models/AssignAccountManagerRequest';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateManagerRelationResponse} from '../models/UpdateManagerRelationResponse';

export interface GetBulkResult$Request {
    id: string;
}

export interface GetBulkResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getBulkResultRequest = createAction<PayloadData<void, GetBulkResult$Request>>('ACCOUNT_MANAGER_BULK__GET_BULK_RESULT__REQUEST');
export const getBulkResultSuccess = createAction<PayloadData<UpdateManagerRelationResponse, GetBulkResult$Request>>('ACCOUNT_MANAGER_BULK__GET_BULK_RESULT__SUCCESS');
export const getBulkResultFailure = createAction<PayloadData<Error, GetBulkResult$Request, true>>('ACCOUNT_MANAGER_BULK__GET_BULK_RESULT__FAILURE');

export const getBulkResultActions = [
    getBulkResultRequest,
    getBulkResultSuccess,
    getBulkResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getBulkResult = (meta: GetBulkResult$Request, config?: GetBulkResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getBulkResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/account-manager-relations`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUpdateRelationsProgress$Request {
    id: string;
}

export interface GetUpdateRelationsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUpdateRelationsProgressRequest = createAction<PayloadData<void, GetUpdateRelationsProgress$Request>>('ACCOUNT_MANAGER_BULK__GET_UPDATE_RELATIONS_PROGRESS__REQUEST');
export const getUpdateRelationsProgressSuccess = createAction<PayloadData<BulkProgress, GetUpdateRelationsProgress$Request>>('ACCOUNT_MANAGER_BULK__GET_UPDATE_RELATIONS_PROGRESS__SUCCESS');
export const getUpdateRelationsProgressFailure = createAction<PayloadData<Error, GetUpdateRelationsProgress$Request, true>>('ACCOUNT_MANAGER_BULK__GET_UPDATE_RELATIONS_PROGRESS__FAILURE');

export const getUpdateRelationsProgressActions = [
    getUpdateRelationsProgressRequest,
    getUpdateRelationsProgressSuccess,
    getUpdateRelationsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUpdateRelationsProgress = (meta: GetUpdateRelationsProgress$Request, config?: GetUpdateRelationsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getUpdateRelationsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/accounts/account-manager-relations/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopBulkAction$Request {
    id: string;
}

export interface StopBulkAction$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopBulkActionRequest = createAction<PayloadData<void, StopBulkAction$Request>>('ACCOUNT_MANAGER_BULK__STOP_BULK_ACTION__REQUEST');
export const stopBulkActionSuccess = createAction<PayloadData<void, StopBulkAction$Request>>('ACCOUNT_MANAGER_BULK__STOP_BULK_ACTION__SUCCESS');
export const stopBulkActionFailure = createAction<PayloadData<Error, StopBulkAction$Request, true>>('ACCOUNT_MANAGER_BULK__STOP_BULK_ACTION__FAILURE');

export const stopBulkActionActions = [
    stopBulkActionRequest,
    stopBulkActionSuccess,
    stopBulkActionFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopBulkAction = (meta: StopBulkAction$Request, config?: StopBulkAction$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopBulkActionActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/accounts/account-manager-relations`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateAccountManagerBulk$Request {
    reason?: string;
    assignAccountManagerRequest?: Array<AssignAccountManagerRequest>;
}

export interface UpdateAccountManagerBulk$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountManagerBulkRequest = createAction<PayloadData<void, UpdateAccountManagerBulk$Request>>('ACCOUNT_MANAGER_BULK__UPDATE_ACCOUNT_MANAGER_BULK__REQUEST');
export const updateAccountManagerBulkSuccess = createAction<PayloadData<string, UpdateAccountManagerBulk$Request>>('ACCOUNT_MANAGER_BULK__UPDATE_ACCOUNT_MANAGER_BULK__SUCCESS');
export const updateAccountManagerBulkFailure = createAction<PayloadData<Error, UpdateAccountManagerBulk$Request, true>>('ACCOUNT_MANAGER_BULK__UPDATE_ACCOUNT_MANAGER_BULK__FAILURE');

export const updateAccountManagerBulkActions = [
    updateAccountManagerBulkRequest,
    updateAccountManagerBulkSuccess,
    updateAccountManagerBulkFailure
] as const;

/**
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {Array<AssignAccountManagerRequest>} [meta.assignAccountManagerRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccountManagerBulk = (meta: UpdateAccountManagerBulk$Request, config?: UpdateAccountManagerBulk$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: updateAccountManagerBulkActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/accounts/account-manager-relations`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.assignAccountManagerRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

